/** @flow */

export default {
  type: "object",
  required: ["activeFrom"],
  properties: {
    id: {
      type: "integer",
      title: "Assignment Rule",
    },
    isCascading: {
      type: "boolean",
      title: "Is Cascading",
    },
    activeFrom: {
      type: "string",
      title: "Active From",
      format: "date-time",
    },
    activeTo: {
      type: ["string", "null"],
      title: "Active To",
      format: "date-time",
    },
    target: {
      type: "object",
      required: ["id"],
      title: "Target",
      properties: {
        id: {
          type: "integer",
          title: "Assignment Target",
        },
      },
    },
    exclusions: {
      type: "array",
      title: "Exclusions",
      items: {
        type: "object",
        required: ["isCascading", "activeFrom", "target"],
        properties: {
          target: {
            type: "object",
            required: ["id"],
            title: "Target",
            properties: {
              id: {
                type: "integer",
                title: "Assignment Target",
              },
            },
          },
          activeFrom: {
            type: "string",
            title: "Active From",
            format: "date-time",
          },
          activeTo: {
            type: ["string", "null"],
            title: "Active To",
            format: "date-time",
          },
          isCascading: {
            type: "boolean",
            title: "Is Cascading",
          },
        },
      },
    },
  },
};
